// extracted by mini-css-extract-plugin
export var con = "pcViewer-module--con--3udxJ";
export var conBig = "pcViewer-module--conBig--3w47a";
export var info = "pcViewer-module--info--3LTu-";